// Material list with categories and types
export const MATERIAL_CATEGORIES = {
  // Building Materials
  SAND: "Sand",
  BALLAST: "Ballast",
  CEMENT: "Cement",
  REINFORCEMENT: "Reinforcement",
  MARINE_PLY: "Marine Ply",
  FUEL: "Fuel",
  STONES: "Stones",
  BINDING: "Binding",
  WIRE: "Wire",
  NAILS: "Nails",
  HOLLOW_POTS: "Hollow Pots",
  TIMBER: "Timber",
  // Tools
  HEAVY_MACHINERY_EQUIPMENT: "HEAVY MACHINERY & EQUIPMENT",
  CONCRETE_EQUIPMENT: "CONCRETE EQUIPMENT",
  CONCRETE_PUMP_PARTS: "CONCRETE PUMP PARTS",
  SCAFFOLDING_SUPPORT_SYSTEMS: "SCAFFOLDING & SUPPORT SYSTEMS",
  SUPPORT_BEAMS: "SUPPORT BEAMS",
  FORMWORK_CASTING: "FORMWORK & CASTING",
  HAND_TOOLS: "HAND TOOLS",
  MEASURING_LAYOUT_TOOLS: "MEASURING & LAYOUT TOOLS",
  TRANSPORT_MATERIAL_HANDLING: "TRANSPORT & MATERIAL HANDLING",
  STORAGE_CONTAINERS: "STORAGE & CONTAINERS",
  FASTENERS_HARDWARE: "FASTENERS & HARDWARE",
  SAFETY_EQUIPMENT: "SAFETY EQUIPMENT",
  FURNITURE_SITE_SETUP: "FURNITURE & SITE SETUP",
  MISCELLANEOUS: "MISCELLANEOUS",
} as const;

export const MATERIAL_ITEMS = {
  // Building Materials
  [MATERIAL_CATEGORIES.SAND]: ["River Sand", "Rock Sand"],
  [MATERIAL_CATEGORIES.BALLAST]: ["Ballast"],
  [MATERIAL_CATEGORIES.CEMENT]: ["Cement 42.5", "Cement 32.5"],
  [MATERIAL_CATEGORIES.REINFORCEMENT]: [
    "D8",
    "D10",
    "D12",
    "D16",
    "D20",
    "D25",
    "D32",
  ],
  [MATERIAL_CATEGORIES.MARINE_PLY]: ["Marine Ply"],
  [MATERIAL_CATEGORIES.FUEL]: ["Diesel", "Petro"],
  [MATERIAL_CATEGORIES.STONES]: [
    'Machine Cut - 4"',
    'Machine Cut - 6"',
    'Machine Cut - 8"',
    "Natural Stone",
  ],
  [MATERIAL_CATEGORIES.BINDING]: ["Binding"],
  [MATERIAL_CATEGORIES.WIRE]: ["Wire"],
  [MATERIAL_CATEGORIES.NAILS]: ["Nails"],
  [MATERIAL_CATEGORIES.HOLLOW_POTS]: ["Hollow Pots"],
  [MATERIAL_CATEGORIES.TIMBER]: ["Timber"],
  // Tools
  [MATERIAL_CATEGORIES.HEAVY_MACHINERY_EQUIPMENT]: [
    "Bobcat machine",
    "Mixer machine",
    "Batching Plant",
    "Dumping level",
    "JCB",
    "Water pump",
    "South Conc Pump",
    "Concrete Pump SP-1200",
  ],
  [MATERIAL_CATEGORIES.CONCRETE_EQUIPMENT]: [
    "Vibrator Poker",
    "Cube moulds",
    "Casting rod",
    "Gauge boxes",
    "Copping moulds",
    "Window seal mould",
    "Coupling moulds",
    "Moulding cube",
  ],
  [MATERIAL_CATEGORIES.CONCRETE_PUMP_PARTS]: [
    "Conc Pump Pipe (1m, 2m, 3m)",
    "Conc Pump Main Pipe",
    "Conc Pump Pipe 90° Bend",
    "Conc Pump Pipe 45° Bend",
    "Conc Pump Pipe 60° Bend",
    "Reducing Pipe",
    "Conc Pump Clamps",
    "Conc Pump Main Clamps",
    "Conc pump Ball",
    "Red Concrete Pipes",
    "Clamp Rubbers",
  ],
  [MATERIAL_CATEGORIES.SCAFFOLDING_SUPPORT_SYSTEMS]: [
    "Scaffolds",
    "Makasi",
    "Cuplock (various sizes: 1.2m, 2m, 2.5m)",
    "Cuplock Ledger (1.2m, 2.4m)",
    "Cuplock Bracket",
    "Round Pipe (various sizes: 1m, 1.2m, 1.4m, 2m, 2.5m, 3m, 6m)",
    "Scaffolding Clamps",
    "Connectors",
    "Screw Jack (Big, Small, L-shape, Big U, Small U)",
    "Flat base",
    "Scaffolding stands",
    "Universal clamps",
    "Metal Trappers (various sizes: 600x120, 300x120, 200x120)",
    "Light gauge prop (4m)",
    "Heavy gauge prop (4m)",
  ],
  [MATERIAL_CATEGORIES.SUPPORT_BEAMS]: [
    "Support Beam (1.2m, 1.8m, 2.4m, 3.6m, 4.2m)",
    "Slab Beam",
    "Aluminium Beam",
    "H-beam (5m)",
    "Column support beam",
  ],
  [MATERIAL_CATEGORIES.FORMWORK_CASTING]: [
    "Column box (300x300)",
    "Tie rods",
    "Push and pull drops",
    "Light gauge drops",
  ],
  [MATERIAL_CATEGORIES.HAND_TOOLS]: [
    "Spade",
    "Mattock",
    "Jembe",
    "Crowbars",
    "Kibui",
    "Modified Kibui",
    "Panga (including damaged)",
    "Shokas (axes)",
    "Mason Hammer",
    "Mallet",
    "Sururu",
    "Slashers",
    "Shovels",
  ],
  [MATERIAL_CATEGORIES.MEASURING_LAYOUT_TOOLS]: ["Tape measure"],
  [MATERIAL_CATEGORIES.TRANSPORT_MATERIAL_HANDLING]: ["Wheelbarrow"],
  [MATERIAL_CATEGORIES.STORAGE_CONTAINERS]: [
    "Metal water tank",
    "Plastic Tank",
    "Metallic Tanks",
  ],
  [MATERIAL_CATEGORIES.FASTENERS_HARDWARE]: ["Nuts & Bolts"],
  [MATERIAL_CATEGORIES.SAFETY_EQUIPMENT]: [
    "First aid kit",
    "Helmets",
    "Reflector jackets",
    "Gumboots",
    "Safety Belts",
  ],
  [MATERIAL_CATEGORIES.FURNITURE_SITE_SETUP]: ["Plastic Chairs", "Table"],
  [MATERIAL_CATEGORIES.MISCELLANEOUS]: ["Hose Pipe", "Solar Lights", "Spanner"],
} as const;

export const MATERIAL_TYPES = {
  [MATERIAL_CATEGORIES.SAND]: ["River Sand", "Rock Sand"],
  [MATERIAL_CATEGORIES.BALLAST]: ["Ballast"],
  [MATERIAL_CATEGORIES.CEMENT]: ["Cement 42.5", "Cement 32.5"],
  [MATERIAL_CATEGORIES.REINFORCEMENT]: [
    "D8",
    "D10",
    "D12",
    "D16",
    "D20",
    "D25",
    "D32",
  ],
  [MATERIAL_CATEGORIES.MARINE_PLY]: ["Marine Ply"],
  [MATERIAL_CATEGORIES.FUEL]: ["Diesel", "Petro"],
  [MATERIAL_CATEGORIES.STONES]: [
    'Machine Cut - 4"',
    'Machine Cut - 6"',
    'Machine Cut - 8"',
    "Natural Stone",
  ],
  [MATERIAL_CATEGORIES.BINDING]: ["Binding"],
  [MATERIAL_CATEGORIES.WIRE]: ["Wire"],
  [MATERIAL_CATEGORIES.NAILS]: ["Nails"],
  [MATERIAL_CATEGORIES.HOLLOW_POTS]: ["Hollow Pots"],
  [MATERIAL_CATEGORIES.TIMBER]: ["Timber"],
} as const;

// Flattened list of all materials for backward compatibility
export const MATERIAL_LIST = Object.values(MATERIAL_TYPES).flat();
